import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from "@tanstack/react-query";
import adminApiClient, { ClockMetadata } from "../../../api/admin";
import { Device } from "../../../Types";

interface UpdateClockMetadataParams {
  metadata: Partial<ClockMetadata>;
}

export function useUpdateClockMetadataMutation(
  deviceId: string,
): UseMutationResult<ClockMetadata, Error, UpdateClockMetadataParams> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ metadata }: UpdateClockMetadataParams) => {
      return await adminApiClient.updateClockMetadata(deviceId, metadata);
    },
    onSuccess: (data) => {
      queryClient.setQueryData(
        ["clockMetadata", deviceId],
        (oldData: Device) => ({
          ...oldData,
          ...data,
        }),
      );
    },
  });
}
